define.alias("shared/components/shared/social/refresh-profile/facebook", "media/components/shared/social/refresh-profile/facebook");